import { injectReducer } from '../../store/reducers';

export default store => (
  {
    path: 'commissions',
    /*  Async getComponent is only invoked when route matches   */
    getComponent(nextState, cb) {
      const Commissions = require('./containers/CommissionsContainer').default; // eslint-disable-line global-require
      const reducer = require('./modules/commission').default; // eslint-disable-line global-require

      injectReducer(store, { key: 'commission', reducer });
      /*  Return getComponent   */
      cb(null, Commissions);
    },

    // childRoutes: [
    //   {
    //     path: ':id(/:detail)',
    //     getComponent(nextState, cb) {
    //       const DetailContainer = require('./containers/CommissionDetailContainer').default; // eslint-disable-line global-require
    //       const reducer = require('./modules/commission').default; // eslint-disable-line global-require
    //       injectReducer(store, { key: 'commission', reducer });
    //
    //       cb(null, DetailContainer);
    //     },
    //   },
    // ],
  }
);



// WEBPACK FOOTER //
// src/routes/commissions/index.js